import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { LanguageConsumer } from '../../context/LanguageContext'
import { ListingConsumer } from '../../context/ListingContext'
import { FormLoader } from '../Loader/FormLoader'
import GeneralTableWithFilter from '../GeneralTableWithFilter'
import { useStyles } from './Styles'
import Moment from 'react-moment'
import moment from 'moment'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'
import { NamedRoutes } from '../../routes'
import { formatRoute } from 'react-router-named-routes'

const LateSubmissionRequestsList = ({ listingData, locale }) => {
  const intl = useIntl()
  const classes = useStyles()
  const columns = [
    {
      name: 'requestId',
      key_name: 'requestId',
      label: intl.formatMessage({ id: 'Fields.label.view.lateSubmission.requestNumber' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.id
          return !!value &&
            <NavLink
              to={formatRoute(NamedRoutes.singleLateSubmission, { id: value })}>{value}</NavLink>
        }
      }
    },
    {
      name: 'activationDate',
      key_name: 'activationDate',
      label: intl.formatMessage({ id: 'Fields.label.view.lateSubmission.start' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.activationDate
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
              <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                format="hh:mm A">{value}</Moment></span>
            </div>
        }
      }
    },
    {
      name: 'expirationDate',
      key_name: 'expirationDate',
      label: intl.formatMessage({ id: 'Fields.label.view.lateSubmission.end' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.expiryDate
          return !!value &&
            <div className={classes.cellDataWrapper}>
              <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
              <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                format="hh:mm A">{value}</Moment></span>
            </div>
        }
      }
    },
    {
      name: 'reason',
      key_name: 'Reason',
      label: intl.formatMessage({ id: 'Fields.label.view.lateSubmission.reason' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = locale === 'en' ? listingData[dataIndex]?.reasonId?.nameEn : listingData[dataIndex]?.reasonId?.nameAr
          return !!value && <div>
            {value}
          </div>
        }
      }
    },
    // {
    //   name: 'requestedBy',
    //   key_name: 'RequestedBy',
    //   label: intl.formatMessage({ id: 'Fields.label.view.lateSubmission.requestedBy' }),
    //   options: {}
    // },moment(getQuarterDate(1, new Date(year).getFullYear().toString())).isAfter(moment())
    {
      name: 'status',
      key_name: 'Status',
      label: intl.formatMessage({ id: 'Fields.label.view.lateSubmission.status' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let isAfter = moment(listingData[dataIndex]?.expiryDate).isAfter(moment())
          return <div className={classes.statusWrapper + (!!isAfter ? '' : ' closed')}>
            <FormattedMessage id={`LateSubmission.Request.Status.${!!isAfter ? 'open' : 'closed'}`} />
          </div>
        }
      }
    }
  ]

  return (
    <LanguageConsumer>
      {({ locale }) => (
        <ListingConsumer>
          {({ listingCount, listingRowsPerPage, listingPage, handleChangeListingPage, handleChangeListingRowsPerPage, listingLoading }) => (
            <div className={'listing-wrapper'}>
              <GeneralTableWithFilter
                columns={columns}
                type={'LateSubmission'}
                noFilter
                listingData={listingData}
                listingCount={listingCount}
                listingRowsPerPage={listingRowsPerPage}
                listingPage={listingPage}
                handleChangeListingPage={handleChangeListingPage}
                handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                locale={locale}
                titleKey={'LateSubmissionPageContent.PageTitle'}
              />
              {!!listingLoading && <FormLoader loading={true} />}
            </div>
          )}
        </ListingConsumer>
      )}
    </LanguageConsumer>
  )
}

export default LateSubmissionRequestsList